/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgJira = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.543 2c0 2.4 1.943 4.343 4.343 4.343h1.77v1.714c0 2.4 1.944 4.343 4.344 4.343V2.83a.829.829 0 0 0-.828-.83h-9.63zM6.77 6.8c0 2.4 1.943 4.343 4.343 4.343h1.771v1.714c0 2.4 1.944 4.343 4.344 4.343V7.628A.83.83 0 0 0 16.4 6.8H6.771zM2 11.6a4.34 4.34 0 0 0 4.343 4.343h1.771v1.714c0 2.4 1.944 4.343 4.343 4.343v-9.571a.83.83 0 0 0-.828-.83H2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgJira as Jira };
